import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Auth0User } from 'src/app/shared/models/auth0User';
import { Auth0Service } from 'src/app/shared/services/auth0.service';

/** sets ActivatedRoute.snapshot.data['auth0User'] */
@Injectable()
export class AccountCreationResolver {
  constructor(private auth0Service: Auth0Service) {}

  resolve(route: ActivatedRouteSnapshot): Observable<Auth0User> {
    return this.auth0Service.getBySecureLinkId(route.params.secureLinkId);
  }
}
